import React, { useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import { DialogComponent } from '@/components/DialogComponent';
import { DialogProps } from '@/components/EditorBuilder/Settings/types';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import Tabs from '@/components/Tabs';
// import { DialogProps } from '@/modules/corporate/modules/course/views/CourseBuilder/components/SidebarDetails/Settings/types';
import { PointsConfig as PointsConfigComponent } from '@/modules/corporate/modules/path/views/PathEditor/components/PointsConfig';
import { PointsConfig, UpsertCourseInput } from '@/types/schema';

import Badges from './Badges';
import { TabValuesEnum } from './types';
const MODAL_CLASSES: React.ComponentProps<typeof DialogComponent>['classes'] = {
  paper: 'h-full',
};
const PointsAndBadges: React.FC<DialogProps> = ({ content, onClose, onSubmit }) => {
  const { t } = useTranslation(['Course']);
  const [badgeIds, setBadgeIds] = useState<string[]>(content.badgeIds as string[]);
  const [pointsConfig, setPointsConfig] = useState<PointsConfig>(
    content.pointsConfig as PointsConfig,
  );
  const tabValues = [
    {
      label: t('Course:Form.Badges'),
      value: TabValuesEnum.Badges,
    },
    {
      label: t('Course:Form.Points'),
      value: TabValuesEnum.Points,
    },
  ];
  const [selectedTab, setSelectedTab] = useState<TabValuesEnum>(tabValues[0].value);

  const onChangeTab = useCallback((value: TabValuesEnum) => {
    setSelectedTab(value);
  }, []);

  const getSnackbarMessage = () =>
    selectedTab == TabValuesEnum.Badges
      ? t('Course:Form.BadgeSuccessfullyAttached')
      : t('Course:Form.PointsSuccessfullyAttached');

  const onSubmitHandler = () => {
    const input: UpsertCourseInput = {};
    if (selectedTab == TabValuesEnum.Badges) {
      input.badgeIds = { set: badgeIds };
    } else {
      input.pointsConfig = pointsConfig;
    }
    onSubmit?.(input, { message: getSnackbarMessage() });
    onClose();
  };

  return (
    <Modal
      action={{
        onSubmit: onSubmitHandler,
        text:
          selectedTab == TabValuesEnum.Badges
            ? t('Course:Form.AttachBadges')
            : t('Course:Form.AttachPoints'),
      }}
      classes={MODAL_CLASSES}
      header={{
        title: t('Course:Form.BadgesAndPoints'),
        description: t('Course:Form.BadgesAndPointsDescription'),
      }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      <Box className="flex flex-1 flex-col px-24 pb-24">
        <Tabs
          className="ms-4"
          tabs={tabValues}
          value={selectedTab}
          variant="small"
          onChange={onChangeTab}
        />
        {selectedTab == TabValuesEnum.Badges ? (
          <Badges value={badgeIds} onChange={setBadgeIds} />
        ) : (
          <PointsConfigComponent value={pointsConfig} onChange={setPointsConfig} />
        )}
      </Box>
    </Modal>
  );
};

export default React.memo(PointsAndBadges);
